import { render, staticRenderFns } from "./StringFormatter.Split.vue?vue&type=template&id=ff9c9b40&scoped=true"
import script from "./StringFormatter.Split.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Split.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.Split.vue?vue&type=style&index=0&id=ff9c9b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9c9b40",
  null
  
)

export default component.exports